import * as tslib_1 from "tslib";
import { TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BreakpointService } from './breakpoint.service';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
/* Wrapper for the MatDialog
 * - supports displaying dialogs in full-screen on mobile devices
 */
var ApMatDialogService = /** @class */ (function () {
    function ApMatDialogService(_dialog, _breakpointService, scrollStrategryOptions, document) {
        this._dialog = _dialog;
        this._breakpointService = _breakpointService;
        this.scrollStrategryOptions = scrollStrategryOptions;
        this.document = document;
    }
    ApMatDialogService.prototype.open = function (componentOrTemplateRef, config) {
        var _this = this;
        if (!config) {
            config = new MatDialogConfig();
            config.maxWidth = '100vw';
        }
        else if (!config.maxWidth) {
            config.maxWidth = '100vw';
        }
        if (config != null && config.fullscreen === true) {
            config.width = '100%';
            config.height = '100%';
            this.document.body.classList.add('ap-disable-scroll');
        }
        var dialogRef = this._dialog.open(componentOrTemplateRef, tslib_1.__assign({}, config, { scrollStrategy: this.scrollStrategryOptions.block() }));
        var handsetSubscription = this._breakpointService.isMobileView
            .subscribe(function (isMatch) {
            if (isMatch) {
                dialogRef.updateSize('100%', '100%');
            }
            else {
                dialogRef.updateSize(config.width, config.height);
            }
        });
        dialogRef.afterClosed()
            .subscribe(function () {
            if (config != null && config.fullscreen === true) {
                _this.document.body.classList.remove('ap-disable-scroll');
            }
            handsetSubscription.unsubscribe();
        });
        return dialogRef;
    };
    return ApMatDialogService;
}());
export { ApMatDialogService };
